import labels from "emun.media/_labels";
import filters from "emun.media/media-container.filters";
import sortOptions from "emun.media/media-container.sort-options";
import templates from "emun.media/media-container.templates";
import views from "emun.media/media-container.views";
import mediaPrompt from "emun.media/media-prompt";
import Media from "emun.media/media.model";
import productPicker from "emun.products/picker/product-picker";
import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";

export const DEFAULT_MODAL_OPTS = {
  placement: "center",
  backdrop: "static",
  size: "md",
  colSplit: 0,
};

export default class MediaContainerController extends BasicAutoQueryController {
  getQuery() {
    const $ctrl = this;
    $ctrl.ngModel = this;
    $ctrl.labels = labels;
    $ctrl.templates = templates;
    $ctrl.mode = "medium";
    console.debug("MediaContainerController", $ctrl);
    return {
      url: `QueryMedia.json`,
      // fields:
      //   "Id,Label,Type,Active,VendorId,RepCustom,ExpiresOn,PublishOn,CreatedOn",
      tagTotalsUrl: `QueryMediaTagTotals.json`,
      // orderBy: "-mediaDate,-Id",
      disableQueryString: $ctrl.disableQueryString !== false,
      pageSize: 12,
      criteria: {
        realm: $ctrl.realm || $ctrl.shard || "products",
        // type: "Hotspot",
        // online: $ctrl.canManage() ? undefined : true,
        // ...($ctrl.$state.current.name.includes("media-admin")
        //   ? {}
        //   : { publishOnBefore: new Date(), expiresOnAfter: new Date() }),
      },
      filters: $ctrl.filters || filters,
      views: $ctrl.views || views,
      templates: $ctrl.templates || templates,
      view: $ctrl.layout || Object.keys(views)[1],
      // navs: ["Dudley"], filters,
      hideLeftNav: true, //!$ctrl.landingPageTagKind, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      sortOptions,
      tagCriteria: Object.assign({}, $ctrl.tagCriteria, $ctrl.tags),
      scrub(res) {
        res.data.results = res.data.results.map((media) => new Media(media));
      },
    };
  }

  thumbnailConstrainTo() {
    const $ctrl = this;
    return $ctrl.isFullscreen
      ? 0
      : $ctrl.mode === "large"
      ? 600
      : $ctrl.mode === "medium"
      ? 300
      : 150;
  }

  editMedia(media, options = DEFAULT_MODAL_OPTS) {
    console.debug("editMedia", { media, options });
    const $ctrl = this;
    return mediaPrompt({
      media,
      ...options,
    }).then(({ $delete, $toggle, $update, $file }) => {
      let promise = null;
      if ($delete) {
        promise = $ctrl.deleteMedia($delete);
      } else if ($toggle) {
        promise = $ctrl.toggleMedia($toggle);
      } else if ($update) {
        if ($file) {
          promise = $ctrl.bus.upload("CreateMedia.json", {
            request: {
              ...$update,
              replacePredecessor: true,
              predecessorId: $update.id,
              id: null,
              euid: null,
              url: null,
              height: null,
              width: null,
              bus: null,
              images: null,
              imageUrls: null,
            },
            files: [$file],
          });
        } else {
          promise = $ctrl.bus.send("UpdateMedia.json", {
            ...$update,
          });
        }
      }
      if (promise) {
        return promise.then(() => $ctrl.query.load());
      }
    });
  }

  addMedia() {
    const $ctrl = this;
    $ctrl.editMedia({ position: $ctrl.query.total + 1 });
  }

  canManage() {
    const $ctrl = this;
    return !$ctrl.$session.isOffline(); //&&
    // $ctrl.$state.current.name.split(".")[0].endsWith("media-admin") &&
    // $ctrl.$session.hasPermission("ManageMedia")
  }

  upload($files) {
    const $ctrl = this;
    if ($files && $files.length) {
      const req = {
        realm: $ctrl.realm,
        tags: $ctrl.query.getTagCriteria(),
      };

      return $ctrl.bus
        .upload("CreateMedia.json", {
          request: req,
          files: $files,
        })
        .then(() => $ctrl.query.load(true));
    }
  }

  manageMediaProducts(
    media,
    options = {
      ...DEFAULT_MODAL_OPTS,
      placement: "right",
      criteria: {
        op: "manageMediaProducts",
        IncludeInactive: true,
      },
    }
  ) {
    const $ctrl = this;
    const {
      tags: { $skus: productIds = [] },
    } = media;
    return productPicker({
      title: "Manage product(s)...",
      applyTagsButtonText: false,
      single: false,
      viewSelections: productIds.length > 0,
      selected: productIds.reduce(
        (m, id) => Object.assign(m, { [id]: true }),
        {}
      ),
      // onProductSelected: (e) => $ctrl.productPickerOnProductSelected(e),
      ...options,
    }).then((result) =>
      $ctrl.bus
        .send("UpdateMedia.json", {
          ...media,
          tags: { ...media.tags, $skus: Object.keys(result) },
        })
        .then(({ data: updated }) =>
          console.debug("ApplyMediaTags", Object.assign(media, updated))
        )
    );
  }

  deleteMedia(media) {
    const $ctrl = this;
    return $ctrl.$modals
      .confirm("Delete media", media.label)
      .result.then(() => {
        return $ctrl.bus
          .send("DeleteMedia.json", media)
          .then((res) => $ctrl.query.load(true));
      });
  }

  toggleMedia(m, skip, activated) {
    const $ctrl = this;
    if (activated !== true && activated !== false) activated = !m.active;
    const verb = `${m.active ? "Dea" : "A"}ctivate`;
    const url = `${verb}Media/${m.id}.json`;
    console.debug("toggleMedia", { m, activated, url, verb });
    return $ctrl.$modals.confirm(`${verb} media`, m.label).result.then(() => {
      m.active = activated;
      m.status = activated ? "Active" : "Inactive";

      $ctrl.bus.send(url).then((res) => {
        Object.assign(m, res.data);
        $ctrl.query.load(true);
      });
    });
  }

  toggleAllMedia(activated) {
    let $ctrl = this;
    $ctrl.query.results.forEach((p) => $ctrl.toggleMedia(p, true, activated));
  }

  addTags() {
    return $ctrl.$modals.alert(
      "This feature has not been implemented as of yet.",
      "Under Construction"
    );
  }

  $onDestroy() {
    this.query.dispose();
  }

  filterStatus(active) {
    const $ctrl = this;
    $ctrl.query.criteria.active = active;
    $ctrl.query.load(true);
  }

  statusLabel(active) {
    return active === true ? "Active" : active === false ? "Inactive" : "All";
  }
}
